import React from 'react';
import { useNavigate } from 'react-router-dom';
import HostAgreementDocument from '../../../components/HostAgreementDocument/HostAgreementDocument';
import './ScreenHostAgreement.css';

export default function ScreenHostAgreement() {
    const navigate = useNavigate();

    return (
        <div className="screen-host-agreement-page">
            <nav className="screen-host-agreement-nav">
                <button type="button" className="screen-host-agreement-brand" onClick={() => navigate('/')}>
                    INVERT
                </button>
            </nav>
            <main className="screen-host-agreement-main">
                <div className="screen-host-agreement-card">
                    <HostAgreementDocument showEsignNotice />
                </div>
            </main>
        </div>
    );
}
